import IAppLogger from '@app/lib/IAppLogger';

let logger: IAppLogger | null = null;

export function setLogger(l: IAppLogger | null) {
  logger = l;
}

function log(message: any, ...optionalParams: any[]): void {
  if (logger) {
    // log rtcs events as debug
    if (message.startsWith('rtcs:')) {
      logger.debug(message, ...optionalParams);
    } else {
      logger.info(message, ...optionalParams);
    }
  }
}

export function logException(err: unknown, message: string): void {
  if (logger) {
    logger.exception(err, message);
  }
}

export default log;
